import $ from 'jquery';

const wishlistModule = (() => {

    function removeURLParameter(url, parameter) {
        //prefer to use l.search if you have a location/link object
        var urlparts= url.split('?');
        if (urlparts.length>=2) {

            var prefix= encodeURIComponent(parameter)+'=';
            var pars= urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i= pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
            return url;
        } else {
            return url;
        }
    }

    function addToWishList(productcode, isOneSize)
    {
        var size = '';
        if(isOneSize=='true') {
            size = 'all';
        } else if ($('input[name="size-options"]:checked').length) {
            size = $('input[name="size-options"]:checked').val();
        }
        var b_id = 'fm_plp_'+productcode;
        var _btn = $("#"+b_id);
        let email = '' ;
        let sectionUrl = '';
        let sessionId = '';
        let canGuestsHaveFavorites = false;
        let wishlistTagId = '';
        let department = window.rcProps.department;

        if (typeof window.rcProps.wishlist != "undefined") {
            email = window.rcProps.wishlist.email;
            sectionUrl = window.rcProps.wishlist.sectionurl;
            sessionId = window.rcProps.wishlist.sessionID;
            wishlistTagId = window.rcProps.wishlist.wishlistTagId;
            canGuestsHaveFavorites = window.rcProps.wishlist.canGuestsHaveFavorites;
            department = department || window.rcProps.pdp.department;
            if ($(".favorite-button-pdp").length > 0) {
                _btn = $(".favorite-button-pdp");
            }
        }

        if (!email && !canGuestsHaveFavorites) {

            var wishlistTagIdPair = wishlistTagId+'='+b_id;
            var wishlistReturnUrl = window.location.pathname+window.location.search;
            if(wishlistReturnUrl.includes(wishlistTagId)) wishlistReturnUrl = removeURLParameter(wishlistReturnUrl, wishlistTagId);
            if(wishlistReturnUrl.includes('?')){
                wishlistReturnUrl = wishlistReturnUrl + '&' + wishlistTagIdPair;
            }else {
                wishlistReturnUrl = wishlistReturnUrl + '?' + wishlistTagIdPair;
            }

            var signInCreateAccountPage = '/fw/addToWishList.jsp?code=' + productcode
                                        + '&size=' + size
                                        + '&sectionURL=' + encodeURIComponent(sectionUrl)
                                        + '&sessionID=' + sessionId
                                        + '&redirect=true&mobile=true&returnUrl='+ encodeURIComponent(wishlistReturnUrl)
                                        + '&d=' + department;
            var signInCreateAccount = '/fw/mobile/Login.jsp?returnURL=' + encodeURIComponent(signInCreateAccountPage);
            showWishListPopup(signInCreateAccount);
        } else {
            var datastring = '&code=' + productcode
                + '&size=' + size
                + '&qty=1&sectionURL=' + encodeURIComponent(sectionUrl)
                + '&d=' + department;
            if (_btn.hasClass("favorite-button--active")){
                datastring = datastring + "&cond=remove";
            } else {
                var wishlistCountUpdater = new WishlistCountUpdater();
                if (wishlistCountUpdater.showWishListMaxRestrictionPopup()) {
                    return;
                }
            }
            var postUrl = "/fw/mobile/ajaxAddToWishlist.jsp?"+datastring;
            $.ajax({
                type: "POST",
                url: postUrl,
                success: function(ajaxResponse){
                    try {
                        var responseObject = JSON.parse(ajaxResponse.trim());
                        if (responseObject.maxPopup) {
                            $("#wishlist_item_count").data('count', responseObject.data);
                            $("#wishlist_item_count").data('limit', responseObject.limit);
                            $('#wish-max-popup-div').empty().append(responseObject.maxPopup);
                            $.modal({triggerOpen: true, open: "restrict-favorites"});
                            return;
                        }
                    }catch (e) {}
                    $("#wish_nav_mpdp").css("display", "none");

                    //wishlist button in plp
                    var wishlistNotifyText = $("#wishlistNotifyText");
                    if (_btn.hasClass("favorite-button--active")) {
                        wishlistNotifyText.text(wishlistNotifyText.data("wishlistadded"));
                        $('#wishlist-link').removeClass('u-hide');
                        _btn.removeClass("favorite-button--active");
                        if(typeof gaUpdateWishList === 'function'){
                            gaUpdateWishList('remove',productcode);
                        }
                        if (typeof insertCordialUpdateWishList === 'function') {
                            insertCordialUpdateWishList('remove', productcode);
                        }
                        if(typeof  taboolaWishListAction === 'function') {
                            taboolaWishListAction("remove", productcode);
                        }

                        if (typeof brazeAddToFavorites === 'function') {
                            if (window.rcProps.pdp !== undefined) {
                                brazeAddToFavorites('remove',
                                    productcode,
                                    window.rcProps.pdp.productName,
                                    size,
                                    window.rcProps.pdp.imageUrl,
                                    window.rcProps.pdp.pdpUrl,
                                    window.rcProps.pdp.retailPrice,
                                    window.rcProps.pdp.currency,
                                    window.rcProps.pdp.department,
                                    window.rcProps.pdp.color,
                                    window.rcProps.pdp.brandName,
                                    window.rcProps.pdp.categoryName,
                                    window.rcProps.pdp.cat1
                                );
                            } else {
                                brazeAddToFavorites('remove',
                                    productcode,
                                    _btn.data('name'),
                                    _btn.data('size'),
                                    _btn.data('imageurl'),
                                    _btn.data('pdpurl'),
                                    _btn.data('price'),
                                    _btn.data('currency'),
                                    _btn.data('department'),
                                    _btn.data('color'),
                                    _btn.data('brand'),
                                    _btn.data('category'),
                                    _btn.data('cat1'),
                                );
                            }
                        }
                    } else {
                        wishlistNotifyText.text(wishlistNotifyText.data("wishlistremoved"));
                        $('#wishlist-link').addClass('u-hide');
                        _btn.addClass("favorite-button--active");
                        if(typeof gaUpdateWishList === 'function'){
                            gaUpdateWishList('add',productcode);
                        }
                        if(typeof iPinYouHeartItem === 'function'){
                            iPinYouHeartItem(productcode);
                        }
                        if(typeof insertRTBHouseHeartItem === 'function'){
                            insertRTBHouseHeartItem(productcode);
                        }
                        if (typeof insertCordialUpdateWishList === 'function') {
                            insertCordialUpdateWishList('add', productcode);
                        }
                        if(typeof  taboolaWishListAction === 'function') {
                            taboolaWishListAction("add", productcode);
                        }

                        if (typeof brazeAddToFavorites === 'function') {
                            if (window.rcProps.pdp !== undefined) {
                                brazeAddToFavorites('add',
                                    productcode,
                                    window.rcProps.pdp.productName,
                                    size,
                                    window.rcProps.pdp.imageUrl,
                                    window.rcProps.pdp.pdpUrl,
                                    window.rcProps.pdp.retailPrice,
                                    window.rcProps.pdp.currency,
                                    window.rcProps.pdp.department,
                                    window.rcProps.pdp.color,
                                    window.rcProps.pdp.brandName,
                                    window.rcProps.pdp.categoryName,
                                    window.rcProps.pdp.cat1
                                );
                            } else {
                                brazeAddToFavorites('add',
                                    productcode,
                                    _btn.data('name'),
                                    _btn.data('size'),
                                    _btn.data('imageurl'),
                                    _btn.data('pdpurl'),
                                    _btn.data('price'),
                                    _btn.data('currency'),
                                    _btn.data('department'),
                                    _btn.data('color'),
                                    _btn.data('brand'),
                                    _btn.data('category'),
                                    _btn.data('cat1'),
                                );
                            }
                        }

                    }
                    if (typeof window.rcProps.wishlist != "undefined") {
                        updateFavoritesMessage(_btn);
                    }
                    //Update header wishlist count
                    var wishlistCountUpdater = new WishlistCountUpdater();
                    wishlistCountUpdater.updateCount();

                }
            });
        }
    }

    function updateFavoritesMessage(favBtn){
        if(!favBtn || favBtn.length == 0)
            return ;

        var favoriteMsg = window.rcProps.wishlist.favoriteMsg;
        var unfavoriteMsg = window.rcProps.wishlist.unfavoriteMsg;
        var favoriteNote = window.rcProps.wishlist.favoriteNote;
        var unfavoriteNote = window.rcProps.wishlist.unfavoriteNote;
        var notificationContainer = '.js-favorite-notify';
        var productDescription = favBtn.data('product-description');

        // Set messaging based on current data attribute value and rcProps values
        let favMessage = "";
        favMessage += favoriteMsg;
        favMessage += productDescription;

        let unFavMessage = "";
        unFavMessage += unfavoriteMsg;
        unFavMessage += productDescription;

        let favNotification = "";
        favNotification += productDescription;
        favNotification += favoriteNote;

        let unFavNotification = "";
        unFavNotification += productDescription;
        unFavNotification += unfavoriteNote;

        var isFav = !favBtn.hasClass('favorite-button--active');

        if(isFav) {
            favBtn.find('.u-screen-reader').html(favMessage);
            favBtn.parent().find(notificationContainer).html(unFavNotification);
        } else {
            favBtn.find('.u-screen-reader').html(unFavMessage);
            favBtn.parent().find(notificationContainer).html(favNotification);
        }
    }

    function showWishListPopup(signInCreateAccount){
        $.modal({
            url: "/fw/content/wishlist/login?href=" + encodeURIComponent(signInCreateAccount),
            type: "top",
            triggerOpen: true,
        });
    }

    function checkWihlistTagId(){
        if(!window.rcProps || !window.rcProps.wishlist) return ;
        var wishlistTagId = window.rcProps.wishlist.wishlistTagId;
        if(window.location.search.includes(wishlistTagId)){
            var urlparts= window.location.search.split('?');
            if (urlparts.length>=2) {
                var pars= urlparts[1].split(/[&;]/g);
                for (var i=0;i<pars.length;i++){
                    console.log('pars[i] = '+pars[i]);
                    if(pars[i].includes(wishlistTagId)){
                        var pair = pars[i].split('=');
                        if (pair.length>0) {
                            console.log('pair[1] = '+pair[1]);
                            console.log('document.getElementById(pair[1]) = '+document.getElementById(pair[1]));
                            if(document.getElementById(pair[1])){
                                console.log('scrollIntoView');
                                document.getElementById(pair[1]).scrollIntoView();
                            }
                        }
                    }
                }
            }
        }
    }

    return {
        checkWihlistTagId : checkWihlistTagId,
        bindWishListEvent: function() {
            $('.js-fav-button').off('click').on('click', function(e){
                var code = $(this).data('code');
                var oneSize = $(this).data('oneSize');
                if(typeof code !== "undefined") {
                    addToWishList(code, oneSize);
                    iPinYouHeartItem(code);
                }
            });
        }
    };
})();

export default wishlistModule;



// WEBPACK FOOTER //
// ./src/scripts/modules/wishlist.js